// extracted by mini-css-extract-plugin
export var item = "kendo-api-breadcrumb-module--item--0b5d3";
export var itemBtn = "kendo-api-breadcrumb-module--itemBtn--175d3";
export var popover = "kendo-api-breadcrumb-module--popover--957e0";
export var popoverItem = "kendo-api-breadcrumb-module--popoverItem--303f9";
export var wrap = "kendo-api-breadcrumb-module--wrap--ffc4d";